import type { FaireProductEntity } from "../../entity_types/product";

export const p_b99zx54aqy: FaireProductEntity = {
  token: "p_b99zx54aqy",
  type: "product",
  name: "Unakite Tower",
  brandToken: "b_2qbyxhh869",
  brandName: "Prettygoods",
  imageUrl:
    "https://cdn.faire.com/fastly/7500fd1492e8c5e8eb1030adbc6bc39a983da2900780d9e82ff33bc2dac99aa1.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.31,
  description:
    "You will receive the item pictured here. All of our crystals and minerals are authentic and high quality. ",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:06.836Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
